<template>
  <div test-id="main" class="pl-2 pr-2 lg:pl-0 lg:pr-0 lg:w-11/12 mx-auto">
    <external-api-payment-type-toggler v-if="isExternalApi" />
    <div
      class="flex flex-col items-center justify-center rounded-lg shadow-xs border px-5 py-5 transition-all duration-300 ease-linear"
      :class="!selectDepositMethod ? 'lg:w-9/12 mx-auto' : ''"
    >
      <p class="font-light text-sm lg:text-base">You will send exactly</p>
      <h3 class="text-2xl mt-1">
        {{ parseMoneyAll(transferDetails.debitAmount, country.currency) }}
      </h3>
      <p class="flex items-center gap-x-3 mt-2">
        <span class="border-b border-solid border-gray-200 w-10 lg:w-28"></span>
        <span
          @click="toggleShow('showBreakDown')"
          class="font-light text-xs lg:text-sm text-primary flex items-center gap-x-1 cursor-pointer"
          ><span>See Breakdown</span>
          <div
            class="transition-all duration-300 transform"
            :class="showBreakDown ? '-rotate-90' : 'rotate-90'"
          >
            <arrow-right-icon />
          </div>
        </span>
        <span class="border-b border-solid w-10 lg:w-28 border-gray-200"></span>
      </p>
      <transition name="fade-in">
        <ul
          v-if="showBreakDown"
          class="w-full text-xs lg:text-sm font-light px-2 lg:px-4 mt-4 text-root-4"
        >
          <li class="flex items-center justify-between mb-4">
            <span>Our fees </span>
            <span>{{
              parseMoneyAll(transferDetails.fees, country.currency)
            }}</span>
          </li>
          <li class="flex items-center justify-between mb-4">
            <span>Amount converted</span>
            <span>
              {{
                parseMoneyAll(
                  transferDetails.debitAmount - transferDetails.fees,
                  country.currency
                )
              }}</span
            >
          </li>
          <li class="flex items-center justify-between mb-4">
            <span>Exchange rate</span>
            <!-- <span>{{ transactionDetails.exchangeRate }}</span> -->
            <div class="text-root-4">
              1
              {{
                !this.isDivisionOperator ? activeCurrency : secondaryCurrency
              }}
              = {{ exchangeRateBase }}
              {{
                !this.isDivisionOperator ? secondaryCurrency : activeCurrency
              }}
            </div>
          </li>
          <li class="flex items-center justify-between mb-4">
            <span>Recipient would receive</span>
            <span class="font-semibold"
              >{{ convertValueTo2DP(transferDetails.recipientAmount || 0) }}
              {{ country2.currency }}</span
            >
          </li>
        </ul>
      </transition>
    </div>
    <select-deposit-method
      v-if="showSelectDepositMethod"
      @initiateTransferHandler="initiateTransferHandler"
      :isLoading="isLoading"
    />
    <wire-transfer-details
      v-if="showWireTransferDetails"
      @closeDialog="done"
      @goToEnterAmount="$emit('goToEnterAmount')"
      :transferType="transferType"
      :useType="useType"
      class="lg:w-9/12 mx-auto"
    />
    <!-- dialogs -->
    <start-wire-transfer
      v-if="showStartWireTransfer"
      :showDialog="showStartWireTransfer"
      @closeDialog="closeDialog('showStartWireTransfer')"
      @startTransfer="startTransferHandler"
    />
    <transaction-processing
      v-if="showTransferProcessingDialog"
      :showDialog="showTransferProcessingDialog"
      @closeDialog="closeTransferProcessingDialog"
      @showSuccess="showSuccess"
    />
    <beneficiary-saved-success-dialog
      v-if="showSuccessDialog"
      :showDialog="showSuccessDialog"
      @closeDialog="closeSuccessDialog"
    />
    <verify-auth-dialog
      :authState="authState"
      v-if="showVerifyAuthDialog"
      :showDialog="showVerifyAuthDialog"
      @closeDialog="closeDialog('showVerifyAuthDialog')"
      @initiateHoldingsTransfer="initiateHoldingsTransfer"
    />
  </div>
</template>

<script>
import country from '@/mixins/getCountryDetails.js'
import exchangeRate from '@/mixins/localDeposit.js'
import breakpoints from '@/utils/breakpoints.js'
import totalAccounts from '@/mixins/getBalance.js'
import terminal from '@/mixins/terminal.js'
import tenant from '@/mixins/tenant.js'
import {
  ConvertValueToXDP,
  ParseMoneyNaira,
  ParseMoney,
  ParseMoneyAll
} from '@/utils/helpers'
export default {
  mixins: [exchangeRate, country, totalAccounts, terminal, tenant],
  name: 'MakePayment',
  props: {
    useType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showWireTransferDetails: false,
      showSelectDepositMethod: true,
      showWireTransferInstructionDialog: false,
      transferType: 'terminal',
      breakpoints,
      showTransferProcessingDialog: false,
      showSuccessDialog: false,
      showBreakDown: false,
      showStartWireTransfer: false,
      selectDepositMethod: true,
      showVerifyAuthDialog: false,
      authState: 'holdingsTransfer',
      isLoading: false
    }
  },
  methods: {
    initiateTransferHandler () {
      if (this.isWireTransferMethod) {
        this.initiateTerminalTransfer(this.currentTransferDetails)
      } else {
        this.showVerifyAuthDialog = true
      }
    },
    handleWireTransfer () {
      this.showSelectDepositMethod = false
      this.showStartWireTransfer = true
      this.showWireTransferDetails = true
    },
    startTransferHandler () {
      this.closeDialog('showStartWireTransfer')
    },
    closeDialog (arg) {
      this[arg] = false
    },
    toggleShow (arg) {
      this[arg] = !this[arg]
    },
    parseMoneyNaira (val) {
      return ParseMoneyNaira(val)
    },
    parseMoney (val) {
      return ParseMoney(val)
    },
    parseMoneyAll (val, currency) {
      return ParseMoneyAll(val, currency)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard')
    },
    convertValueTo2DP (val) {
      return ConvertValueToXDP(val, 2)
    },
    closeTransferProcessingDialog () {
      this.showTransferProcessingDialog = false
    },
    showSuccess () {
      this.showSuccessDialog = true
    },
    closeSuccessDialog () {
      this.$router.push({ name: 'transactions' })
    },
    handleClose () {
      this.showWireTransferInstructionDialog = false
    },
    done () {
      if (this.routeName === 'terminal') {
        this.showTransferProcessingDialog = true
      } else {
        this.$router.push('transactions')
      }
    }
  },
  components: {
    wireTransferDetails: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/WireTransferDetails.vue'
      ),
    ExternalApiPaymentTypeToggler: () =>
      import('@/components/externalApi/ExternalApiPaymentTypeToggler.vue'),
    TransactionProcessing: () =>
      import('@/components/terminal/TransactionProcessing.vue'),
    BeneficiarySavedSuccessDialog: () =>
      import('@/components/terminal/BeneficiarySavedSuccessDialog.vue'),
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue'),
    StartWireTransfer: () =>
      import('@/components/v2/terminal/dialogs/StartWireTransfer.vue'),
    VerifyAuthDialog: () => import('@/components/v2/auth/VerifyAuthDialog.vue'),
    SelectDepositMethod: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/SelectDepositMethod.vue'
      )
  },
  computed: {
    routeName () {
      return this.$route.name
    },
    holdingsAccountIsFunded () {
      return this.selectedHoldingsAccountBalance > 0
    },
    usedBeneficiary () {
      return this.$store.state.terminal.usedBeneficiary
    },
    isHoldingsMethod () {
      return this.depositMethod === 'holdings'
    },
    isWireTransferMethod () {
      return this.depositMethod === 'wire transfer'
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '91%'
    },
    recipientInfo () {
      return (
        this.$store.state.terminal.transferTerminalDetails
          .recipientInformation || {}
      )
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    transferReference () {
      const details = this.$store.state.terminal.transferInfo.localDepositRef
      return details
    },
    fromBalance () {
      return this.$store.state.terminal.terminalTransferType === 'fromBalance'
    },
    isExternalApi () {
      return this.useType === 'externalApi'
    }
  }
}
</script>

<style scoped>
.box {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}
</style>
